<main class="main-wrap">
  
  <div class="wrapper"
    [ngClass]="( url == '/career' || url == '/individual-blog' || url == '/foy-tv'  || url == '/reward' || url == '/contact-us' && url != '/blog-list-two') ? 'career-bg' : ''"
    *ngIf="url && ( url != '/banner' &&  url != '/checkout' && url.indexOf('/checkout-new/cart') == -1 && url.indexOf('/checkout-new/buynow') == -1)">
    <div class="white-bg"
      *ngIf=" url != '/career' && url != '/consultation' && url != '/contact-us' && url != '/foy-tv' && url != '/individual-blog' && url != '/our-community' && url != '/reward' &&  url.indexOf('/checkout-new/cart') == -1 && url.indexOf('/checkout-new/buynow') == -1">
      <div class="header-top-fix">
        <app-header-bg [alphabets]="alphabets" [mGetBrandResponse]="mGetBrandResponse" [customerMenuLists]="customerMenuLists" [url]="url"></app-header-bg>

        <app-sub-header-hover-category  [customerMenuLists]="customerMenuLists"
           *ngIf="url != '/about-us' &&  url != '/faq' && url != '/privacy-policy' && url != '/returns-and-refund' && url != '/shipping-policy'  && url != '/terms-of-service' && url != '/need-help'"></app-sub-header-hover-category>
      </div>
    </div>
    <div class="bg-traperant sub-category sub-text-white"
      [ngClass]="(url != '/coming-soon' && (url == '/career' || url == '/individual-blog' || url != '/foy-tv' || url == '/reward' || url == '/blog-list-two' || url == '/contact-us')) ? '' : 'inner-gradient-bg'"
      *ngIf="url != '/coming-soon' &&(url == '/career' || url == '/consultation' || url == '/contact-us' || url == '/foy-tv' || url == '/individual-blog' || url == '/our-community' || url == '/reward') ">
      <div class="header-top-fix">
        <app-header [alphabets]="alphabets" [mGetBrandResponse]="mGetBrandResponse" [customerMenuLists]="customerMenuLists" [url]="url"></app-header>
        <app-sub-header-white-hover-category [customerMenuLists]="customerMenuLists"
          *ngIf="url == '/consultation' || url == '/our-community'"></app-sub-header-white-hover-category>
      </div>
    </div>
    <app-foy-toast id="toast-message" *ngIf="showToast" [message]="message"></app-foy-toast>
    <router-outlet></router-outlet>
  </div>
  <div
    *ngIf="url && ( url == '/banner' || url == '/checkout' || url.indexOf('/checkout-new/cart') != -1 || url.indexOf('/checkout/buynow') != -1 || url.indexOf('/checkout-new/buynow') != -1)">
    <app-foy-toast  id="toast-message" *ngIf="showToast" [message]="message"></app-foy-toast>
    <router-outlet></router-outlet>
  </div>
</main>